module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"skus":"Prices","about":"About","logout":"Sign Out"},"es":{"skus":"Precios","about":"Acerca de","logout":"Desconectar"},"sw":{"skus":"Bei","about":"Kuhusu","logout":"Ondoka"}}')
  delete Component.options._Ctor
}
